import { Routes, Route } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { MobileBlocker, NotFound } from '@commonClient2/components';
import Login from './components/Login';
import SsoLogin from './components/SsoLogin';
import Employee from './Employee/App';
import Manager from './Manager/App';
import Admin from './Admin/App';
import PrivateRoute from './components/PrivateRoute';
import { fetchPublicConfigs } from './store/publicConfigs';

const ShiftBiddingRoutes = () => {
    const dispatch = useDispatch();
    dispatch(fetchPublicConfigs(!sessionStorage.getItem('hrisUrl')));

    const employeeRedirectUrl = sessionStorage.getItem('employeeRedirectUrl');
    const managerRedirectUrl = sessionStorage.getItem('managerRedirectUrl');
    const adminRedirectUrl = sessionStorage.getItem('adminRedirectUrl');
    
    return (
        <Routes>
            <Route
                path="/login/:target"
                element={<Login />}
            />
            <Route
                path="/sso/:target"
                element={<SsoLogin />}
            />
            <Route
                path="/Employee/*"
                element={(
                    <PrivateRoute
                        redirectUrl={employeeRedirectUrl}
                        loginPage="/login/Employee"
                        requiredLicense="employee"
                    >
                        <Employee />
                    </PrivateRoute>
                )}
            />
            <Route
                path="/Manager/*"
                element={(
                    <PrivateRoute
                        redirectUrl={managerRedirectUrl}
                        loginPage="/login/Manager"
                        requiredLicense="manager"
                    >
                        <MobileBlocker>
                            <Manager />
                        </MobileBlocker>
                    </PrivateRoute>
                )}
            />
            <Route
                path="/Admin/*"
                element={(
                    <PrivateRoute
                        redirectUrl={adminRedirectUrl}
                        loginPage="/login/Admin"
                        requiredLicense="admin"
                    >
                        <MobileBlocker>
                            <Admin />
                        </MobileBlocker>
                    </PrivateRoute>
                )}
            />
            <Route
                path="*"
                element={<NotFound />}
            />
        </Routes>
    );
};

export default ShiftBiddingRoutes;
